import * as angular from "angular";
import {IController} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SettingsService} from "../../services/settings-service.service";
import {RolesGroupsDialogsService} from "../../services/roles-groups-dialogs.service";
import {PoliciesService} from "../../../policies/services/policies-service.service";
import {PoliciesAlertsService} from "../../../policies/services/policies-alerts.service";

export class RolesGroupsComponent implements IController {

  extendedPolicy: any;
  orgId?: string;
  siteId?: string;

  public groups: any;

  constructor(private $log, private policiesService: PoliciesService,
              private policiesAlertsService: PoliciesAlertsService,
              private rolesGroupsDialogsService: RolesGroupsDialogsService,
              private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    if (this.extendedPolicy) {
      this.policiesService.getAllRolesGroups(this.extendedPolicy.policy.id, this.orgId, this.siteId)
        .then((groups: any) => {
          this.groups = groups;
        })
    }
  }

  onCreateGroup(event) {
    this.rolesGroupsDialogsService.createGroup(event, this.extendedPolicy.roles)
      .then((group) => {
        this._onCreateGroup(group);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditGroup(group, $event) {
    const groupCopy = angular.copy(group);
    this.rolesGroupsDialogsService.editGroup($event, groupCopy, this.extendedPolicy.roles)
      .then((payload) => {
        this._onEditGroup(payload, group.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDelete(group, event?) {
    if (group.connectedMembers > 0) {
      this.policiesAlertsService.deleteGroupWithUsersInfo();
      return;
    }
    this.confirmDialogService.confirm('Delete Group', 'Are you sure you want to delete this roles group?', event)
      .then(() => {
        this._onDeleteGroup(group.id)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAddUsers(group, event) {
    this.rolesGroupsDialogsService.addUsers(this.extendedPolicy.users, group.connectedUserIds, event)
      .then((userIds) => {
        this._onAddMembers(group.id, userIds);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onRemoveUsers(group, event) {
    this.rolesGroupsDialogsService.removeUsers(this.extendedPolicy.users, group.connectedUserIds, event)
      .then((userIds) => {
        this._onRemoveMembers(group.id, userIds);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private _onCreateGroup(group) {
    this.policiesService.createRolesGroup(group, this.extendedPolicy.policy.id, this.orgId, this.siteId)
      .then((group: any) => {
        this.groups = this.groups.concat([group.data]);
      });
  }

  private _onDeleteGroup(groupId) {
    this.policiesService.deleteRolesGroup(groupId, this.extendedPolicy.policy.id, this.orgId, this.siteId)
      .then((group) => {
        this.groups = this.groups.filter(group => group.id !== groupId);
      });
  }

  private _onEditGroup(group, groupId) {
    this.policiesService.editRolesGroup(group, groupId, this.extendedPolicy.policy.id, this.orgId, this.siteId)
      .then((updatedGroup: any) => {
        const index = this.groups.findIndex((g: any) => {
          return g.id === groupId;
        })
        if (index > -1) {
          this.groups[index] = updatedGroup.data;
        }
      });
  }

  private _onAddMembers(groupId, userIds) {
    this.policiesService.addMembersToGroup(groupId, this.extendedPolicy.policy.id, userIds, this.orgId, this.siteId)
      .then((updatedGroup) => {
        const index = this.groups.findIndex((g: any) => {
          return g.id === groupId;
        })
        if (index > -1) {
          const groupsCopy = angular.copy(this.groups);
          groupsCopy.splice(index, 1, updatedGroup);
          this.groups = groupsCopy;
        }
      })
  }

  private _onRemoveMembers(groupId, userIds) {
    this.policiesService.removeMembersFromGroup(groupId, this.extendedPolicy.policy.id, userIds, this.orgId, this.siteId)
      .then((updatedGroup) => {
        const index = this.groups.findIndex((g: any) => {
          return g.id === groupId;
        })
        if (index > -1) {
          const groupsCopy = angular.copy(this.groups);
          groupsCopy.splice(index, 1, updatedGroup);
          this.groups = groupsCopy;
        }
      })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('rolesGroups', {
    bindings: {
      extendedPolicy: '<',
      orgId: '<?',
      siteId: '<?'
    },
    template: require('./roles-groups.html').default,
    controller: RolesGroupsComponent
  });
